// extracted by mini-css-extract-plugin
export default {"container":"modal_container__2Ca4x","inner":"modal_inner__Y1c_9","safe":"modal_safe__R0xo1","opened":"modal_opened__C8btk","draw-path":"modal_draw-path__1-o9H"};